import { BackgroundColorEnum } from '@boels/models';
import { of } from 'rxjs';

export const cardsGroupMockData = {
  data$: of({
    uid: 'cmsitem_00196024',
    uuid: 'eyJpdGVtSWQiOiJjbXNpdGVtXzAwMTk2MDI0IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
    typeCode: 'CardsGroupComponent',
    modifiedtime: '2022-11-21T16:55:38.874+01:00',
    name: 'cards1',
    container: false,
    backgroundColor: BackgroundColorEnum.WHITE,
    cards: 'cmsitem_00024037 cmsitem_00024041 cmsitem_00139195 comp_00151025',
    removeBottomSpacing: false,
    children:
      'cmsitem_00024037 cmsitem_00024041 cmsitem_00139195 comp_00151025',
    synchronizationBlocked: false,
    title: 'White bg, with bottom QA MOCK',
  }),
};

export const cardsGroupMockData1 = {
  component: [
    {
      uid: 'cmsitem_00024041',
      uuid: 'eyJpdGVtSWQiOiJjbXNpdGVtXzAwMDI0MDQxIiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
      typeCode: 'CardComponent',
      modifiedtime: '2022-11-21T15:55:38+0000',
      name: 'Veilig werken - Cards',
      container: false,
      image: {
        code: 'veilig-werken-cards.jpg',
        mime: 'image/jpeg',
        altText: 'Veilig werken',
        url: '/medias/veilig-werken-cards.jpg?context=bWFzdGVyfHJvb3R8MTg5MTI0fGltYWdlL2pwZWd8aDY2L2gzYi84ODIxMDk2MDU0ODE0L3ZlaWxpZy13ZXJrZW4tY2FyZHMuanBnfGM4NThkNGQzYzllZGFjODFlODNiYjhmZWU2ZDE5ZGI3NjE1MzlkMWMzNzUzNmNkYjdjYWNmZTFkODRjMDRkNWY',
      },
      imageAltText: 'Working safely - OHO',
      subtitle:
        'Safety is the top priority for you and your employees. Find out how we can help you.',
      synchronizationBlocked: false,
      link: {
        container: false,
        uid: 'cmsitem_00024040',
        external: false,
        name: 'Alles over veilig werken - Link',
        synchronizationBlocked: false,
        uuid: 'eyJpdGVtSWQiOiJjbXNpdGVtXzAwMDI0MDQwIiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
        url: '/working-safely',
        linkName: 'All about working safely',
        typeCode: 'CMSLinkComponent',
        parents: 'cmsitem_00193005',
        target: false,
      },
      title: 'Working safely - QA MOCK',
      parents: 'cmsitem_00151322 cmsitem_00192000 cmsitem_00196024',
    },
    {
      uid: 'cmsitem_00024037',
      uuid: 'eyJpdGVtSWQiOiJjbXNpdGVtXzAwMDI0MDM3IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
      typeCode: 'CardComponent',
      modifiedtime: '2022-11-21T15:55:38+0000',
      name: 'Huren op rekening1 - Cards',
      container: false,
      image: {
        code: 'huren-op-rekening-cards.jpg',
        mime: 'image/jpeg',
        altText: 'Huren op rekening',
        url: '/medias/huren-op-rekening-cards.jpg?context=bWFzdGVyfHJvb3R8MTM5OTU2fGltYWdlL2pwZWd8aDUyL2g1NC84ODIxNTIxNDQ4OTkwL2h1cmVuLW9wLXJla2VuaW5nLWNhcmRzLmpwZ3xiNmNjMTA1MTc4ZjFkY2IzMTU3MDRlN2Y0NjE0Mzg2NzBmNGZiYTcwNzkwYTE2YzZhZDcyYjZiNmY0N2JmNDRl',
      },
      imageAltText: 'Renting on account',
      subtitle:
        'NO LINK With a Boels account, renting is faster at our branches and there is usually no deposit. QA',
      synchronizationBlocked: false,
      title: 'Renting on account - QA MOCK',
      parents: 'cmsitem_00196024 cmsitem_00196025 cmsitem_00196027',
    },
    {
      uid: 'cmsitem_00139195',
      uuid: 'eyJpdGVtSWQiOiJjbXNpdGVtXzAwMTM5MTk1IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
      typeCode: 'CardComponent',
      modifiedtime: '2022-11-21T15:55:38+0000',
      name: 'FAQ - Cards',
      container: false,
      image: {
        code: 'faq-cards.jpg',
        mime: 'image/jpeg',
        altText: 'Frequently asked questions',
        url: '/medias/faq-cards.jpg?context=bWFzdGVyfHJvb3R8MTEwNTQzfGltYWdlL2pwZWd8aGI4L2hlYi85MDUzMTk4MTg4NTc0L2ZhcS1jYXJkcy5qcGd8YzAxMjhmY2ZhZTYwNGMzZTk1MzNiZWViYTRlMTU2M2YwOGM1MjFmYWQ5ODViMGU4ZjgxNzE2YWQxYzUyNzIzOQ',
      },
      imageAltText: 'Frequently asked questions',
      subtitle: 'Visit our page for frequently asked questions. ',
      synchronizationBlocked: false,
      link: {
        container: false,
        uid: 'cmsitem_00139194',
        external: false,
        name: 'FAQ - Link',
        synchronizationBlocked: false,
        uuid: 'eyJpdGVtSWQiOiJjbXNpdGVtXzAwMTM5MTk0IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
        url: '/customer-service/faq',
        linkName: 'Frequently asked questions',
        typeCode: 'CMSLinkComponent',
        target: false,
      },
      title: 'More questions? - QA MOCK',
      parents: 'cmsitem_00151322 cmsitem_00196024 cmsitem_00196026',
    },
    {
      uid: 'comp_00151025',
      uuid: 'eyJpdGVtSWQiOiJjb21wXzAwMTUxMDI1IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
      typeCode: 'CardComponent',
      modifiedtime: '2022-11-21T15:55:38+0000',
      name: 'Zo werkt huren - Cards',
      container: false,
      image: {
        code: 'clone_00059006',
        mime: 'image/jpeg',
        altText: 'Zo werkt huren',
        url: '/medias/zo-werkt-huren-cards.jpg?context=bWFzdGVyfHJvb3R8MzIwOTE5fGltYWdlL2pwZWd8aGQyL2hkNC84ODIwNjcwMDA1Mjc4L3pvLXdlcmt0LWh1cmVuLWNhcmRzLmpwZ3xkMzI4MDYwNDU4YTA4YjdiMGVhNGNlOWNlY2RlNjY0NzIzNzk3OGZiZTE1YmI0MDE1NzdlMDdiNzc3NTFlZWZi',
      },
      imageAltText: 'How renting works',
      subtitle:
        'Is this your first time renting at Boels? We’ll let you know how it works and what it costs.',
      synchronizationBlocked: false,
      link: {
        container: false,
        uid: 'comp_00151026',
        external: true,
        name: 'Zo werkt huren - Link',
        synchronizationBlocked: false,
        uuid: 'eyJpdGVtSWQiOiJjb21wXzAwMTUxMDI2IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
        linkName: 'More information',
        typeCode: 'CMSLinkComponent',
        target: false,
      },
      title: 'How renting works - QA MOCK',
      parents: 'cmsitem_00196024 cmsitem_00196026',
    },
  ],
  pagination: {
    count: 10,
    hasNext: false,
    hasPrevious: false,
    page: 0,
    totalCount: 4,
    totalPages: 1,
  },
  sorts: [],
};
